import { render, staticRenderFns } from "./EditBranchDialog.vue?vue&type=template&id=c057a990&scoped=true"
import script from "./EditBranchDialog.vue?vue&type=script&lang=js"
export * from "./EditBranchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c057a990",
  null
  
)

export default component.exports